/* ==========================================================================
   Klarna On-Site Messaging (OFICIAL · sincronizado) — tema SAY / WIWI
   --------------------------------------------------------------------------
   - Inserta el PLACEMENT OFICIAL de Klarna (<klarna-placement>) JUSTO debajo
     del botón "Add to cart / Comprar" en la PDP.
   - El importe (data-purchase-amount) sale del PRECIO REAL de la variante
     seleccionada (datos de variante del propio tema, en céntimos). No se
     calcula ni se inventa ninguna cuota: Klarna devuelve nº de pagos,
     intereses, importe y elegibilidad.
   - Idioma / país / moneda se derivan del mercado activo (config inyectada en
     el layout: window.SAY_KLARNA_OSM).
   - Si Klarna NO devuelve mensaje (sin client_id, mercado o importe no
     elegible) se muestra SOLO un texto seguro, sin importes.
   - Config en window.SAY_KLARNA_OSM (ver layout/theme.liquid).
   ========================================================================== */
(function () {
  if (window.__sayKlarnaOsm) return;
  window.__sayKlarnaOsm = true;

  var CFG = window.SAY_KLARNA_OSM || {};
  var POLL_MS = 400;
  var POLL_MAX = 25; // ~10s de margen para que Klarna responda

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---- localizar el bloque de botones de compra principal ---- */
  function findAnchor() {
    var sel = [
      '.main-product__buy-buttons--container',
      'product-form',
      'form[action*="/cart/add"]'
    ];
    for (var i = 0; i < sel.length; i++) {
      var nodes = document.querySelectorAll(sel[i]);
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        // evitar el formulario del sticky add-to-cart
        if (n.closest('.wt-product__sticky-buy, [data-sticky-atc], .say-sticky-atc')) continue;
        return n;
      }
    }
    return null;
  }

  /* ---- precio REAL de la variante seleccionada (céntimos) ----
     Fuente autoritativa: Shopify Ajax API /products/{handle}.js
     (precio real de Shopify; sin cálculos). Fast-path: JSON del tema. */
  function fillFromThemeJson(state) {
    document.querySelectorAll('variant-options [type="application/json"], product-info [type="application/json"], script[type="application/json"][data-variants]').forEach(function (s) {
      try {
        var arr = JSON.parse(s.textContent);
        if (Array.isArray(arr)) arr.forEach(function (v) { if (v && v.id != null && v.price != null) state.prices[String(v.id)] = v.price; });
      } catch (e) {}
    });
  }

  function productHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function loadPrices(state, done) {
    fillFromThemeJson(state);
    var h = productHandle();
    if (!h) { done && done(); return; }
    fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p) {
          if (p.price != null) state.fallbackAmount = p.price;
          (p.variants || []).forEach(function (v) { if (v && v.id != null && v.price != null) state.prices[String(v.id)] = v.price; });
        }
        done && done();
      })
      .catch(function () { done && done(); });
  }

  function currentVariantId() {
    var input =
      document.querySelector('product-form form input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? String(input.value) : null;
  }

  function currentAmount(state) {
    var vid = currentVariantId();
    if (vid && state.prices[vid] != null) return state.prices[vid];
    if (state.fallbackAmount != null) return state.fallbackAmount;
    for (var k in state.prices) if (state.prices.hasOwnProperty(k)) return state.prices[k];
    return null;
  }

  /* ---- construir el bloque ---- */
  function buildNode(state) {
    var wrap = document.createElement('div');
    wrap.className = 'klarna-osm';
    wrap.setAttribute('data-klarna-osm', '');

    if (CFG.clientId) {
      var pw = document.createElement('div');
      pw.className = 'klarna-osm__placement';
      var p = document.createElement('klarna-placement');
      p.setAttribute('data-key', CFG.key || 'credit-promotion-badge');
      p.setAttribute('data-locale', CFG.locale || 'es-ES');
      if (CFG.theme) p.setAttribute('data-theme', CFG.theme);
      var amt = currentAmount(state);
      if (amt != null) p.setAttribute('data-purchase-amount', String(amt));
      pw.appendChild(p);
      wrap.appendChild(pw);
    }

    var fb = document.createElement('p');
    fb.className = 'klarna-osm__fallback';
    fb.textContent = (CFG.lang === 'es') ? (CFG.textEs || 'Paga de forma flexible con Klarna, sujeto a aprobación.')
                                         : (CFG.textEn || 'Flexible payments with Klarna, subject to approval.');
    wrap.appendChild(fb);
    return wrap;
  }

  function injectStyles() {
    if (document.getElementById('say-klarna-osm-css')) return;
    var css = document.createElement('style');
    css.id = 'say-klarna-osm-css';
    css.textContent =
      '.klarna-osm{margin-top:12px;width:100%;font-family:inherit}' +
      '.klarna-osm__placement{width:100%}' +
      '.klarna-osm__placement klarna-placement{display:block;width:100%}' +
      '.klarna-osm__fallback{margin:0;font-size:13px;line-height:1.4;letter-spacing:.01em;color:#6a655d}' +
      '.klarna-osm--live .klarna-osm__fallback{display:none}' +
      '@media (max-width:749px){.klarna-osm{margin-top:10px}.klarna-osm__fallback{font-size:12.5px}}';
    document.head.appendChild(css);
  }

  function loadLibrary() {
    if (!CFG.clientId) return;
    if (document.querySelector('script[data-klarna-osm-lib]')) return;
    var s = document.createElement('script');
    s.async = true;
    s.setAttribute('data-klarna-osm-lib', '');
    s.src = 'https://' + (CFG.region || 'eu') + '-library.klarnaservices.com/merchant.js?data-client-id=' + encodeURIComponent(CFG.clientId);
    document.body.appendChild(s);
  }

  /* ---- detección: ¿Klarna ha pintado contenido real? ---- */
  function isRendered(p) {
    if (!p) return false;
    try { if (p.shadowRoot && p.shadowRoot.childElementCount > 0) return true; } catch (e) {}
    if (p.childElementCount > 0) return true;
    return p.getBoundingClientRect().height > 4;
  }

  function evaluate(node) {
    var p = node.querySelector('klarna-placement');
    if (p && isRendered(p)) node.classList.add('klarna-osm--live');
    else node.classList.remove('klarna-osm--live');
  }

  function refresh(node, state) {
    var p = node.querySelector('klarna-placement');
    if (p) {
      var amt = currentAmount(state);
      if (amt != null) p.setAttribute('data-purchase-amount', String(amt));
    }
    try {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    } catch (e) {}
  }

  function poll(node) {
    var n = 0;
    var iv = setInterval(function () {
      n++; evaluate(node);
      if (n >= POLL_MAX) clearInterval(iv);
    }, POLL_MS);
  }

  function init() {
    // si ya existe un bloque renderizado por Liquid (snippet opcional), no duplicar
    if (document.querySelector('[data-klarna-osm]')) return;

    var anchor = findAnchor();
    if (!anchor) return; // PDP sin formulario reconocible (p.ej. GemPages): no mostrar nada flotante

    var state = { prices: {}, fallbackAmount: null };
    injectStyles();
    var node = buildNode(state);

    // insertar JUSTO debajo del bloque de botones de compra
    if (anchor.parentNode) anchor.parentNode.insertBefore(node, anchor.nextSibling);

    loadLibrary();
    // cargar precios REALES (Ajax API) y fijar el importe del placement
    loadPrices(state, function () { refresh(node, state); });
    poll(node);

    function onChange() { refresh(node, state); poll(node); }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name="id"]')) onChange();
    }, true);
    document.addEventListener('variantChangeEnd', onChange, true);

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var v = ev && ev.data && ev.data.variant;
          if (v && v.price != null) {
            var p = node.querySelector('klarna-placement');
            if (p) p.setAttribute('data-purchase-amount', String(v.price));
          }
          onChange();
        });
      }
    } catch (e) {}

    var obs = new MutationObserver(function () { evaluate(node); });
    var pw = node.querySelector('.klarna-osm__placement');
    if (pw) obs.observe(pw, { childList: true, subtree: true });
  }

  ready(init);
})();
